import {
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PostApiV1ThreeLetterCodeClientAdminsUsersBulkCreations201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

export const useBulkCreationUser = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsUsersBulkCreations201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationFetcher(threeLetterCode),
    options
  );
};
